export const sortFunction_alphabetical = (a, b, sortPath = 'name') => {
  const getValue = (obj, path) =>
    path.split('.').reduce((o, key) => o?.[key], obj)

  const valA = getValue(a, sortPath)
  const valB = getValue(b, sortPath)

  if (valA == null && valB == null) return 0
  if (valA == null) return -1
  if (valB == null) return 1

  const nameA = String(valA).toUpperCase()
  const nameB = String(valB).toUpperCase()

  if (nameA < nameB) return -1
  if (nameA > nameB) return 1
  return 0
}

export const shortenStringByEllipsis = (str, maxBytes) => {
  if (!str) return str

  const encoder = new TextEncoder()

  if (encoder.encode(str).length <= maxBytes) return str

  let chars = Array.from(str)
  while (chars.length && encoder.encode(chars.join('') + '...').length > maxBytes) {
    chars = chars.slice(0, -1)
  }

  return chars.join('') + '...'
}